import React, { useState, useEffect } from 'react';
import { getCustomers, createCustomer, updateCustomer, deleteCustomer, getOrders, updateOrder, bulkDeleteCustomers  } from '../services/api';
import Modal from '../components/Modal';
import ConfirmModal from '../components/Confirmmodal';
import Navbar from '../components/Navbar';
import { exportCustomersToExcel } from '../utils/exportUtils';
import toast from 'react-hot-toast';
import '../styles/Pages.css';
import '../styles/Customers.css';
import { useAuth } from '../context/AuthContext';
import { formatCurrency, formatDate } from '../utils/formatters';


const normalizePhone = (phone) => {
  if (!phone) return '';
  return phone.replace(/\D/g, '');
};

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOrdersModalOpen, setIsOrdersModalOpen] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerOrders, setCustomerOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(() => {
  return localStorage.getItem('customerSearch') || '';
});
  const { hasPermission } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(() => {
  const saved = localStorage.getItem('customerPageSize');
  return saved ? Number(saved) : 50;
});

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'danger',
    onConfirm: () => {},
    confirmText: 'Evet',
    loading: false
  });

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    tax_number: '',
    tax_office: '',
    notes: ''
  });

useEffect(() => {
  setLoading(true);
  fetchCustomers(1, searchTerm).finally(() => setLoading(false));
}, []);

useEffect(() => {
  const timer = setTimeout(() => {
    fetchCustomers(1, searchTerm);
  }, 600);
  return () => clearTimeout(timer);
}, [searchTerm]);

useEffect(() => {
  localStorage.setItem('customerSearch', searchTerm);
}, [searchTerm]);

  const fetchCustomers = async (page = 1, search = '', size = pageSize) => {
  try {
    const params = { page, limit: size };
    if (search) params.search = search;
    const response = await getCustomers(params);
    setCustomers(response.data.items);
    setTotalPages(response.data.pages);
    setTotalCount(response.data.total);
    setCurrentPage(page);
  } catch (error) {
    console.error('Error:', error);
    toast.error('Müşteriler yüklenirken hata oluştu');
  }
};

  const formatPhoneNumber = (value) => {
    if (!value) return '';
    let numbers = value.replace(/\D/g, '');
    if (numbers.startsWith('0')) {
      numbers = numbers.slice(1);
    }
    const limited = numbers.slice(0, 10);
    if (limited.length === 0) return '';
    if (limited.length <= 3) return `0(${limited}`;
    if (limited.length <= 6) return `0(${limited.slice(0, 3)}) ${limited.slice(3)}`;
    if (limited.length <= 8) return `0(${limited.slice(0, 3)}) ${limited.slice(3, 6)} ${limited.slice(6)}`;
    return `0(${limited.slice(0, 3)}) ${limited.slice(3, 6)} ${limited.slice(6, 8)} ${limited.slice(8)}`;
  };

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    setFormData({...formData, phone: formatted});
  };

  const handleOpenModal = (customer = null) => {
    if (customer) {
      setEditingCustomer(customer);
      setFormData({
        name: customer.name || '',
        phone: customer.phone || '',
        email: customer.email || '',
        address: customer.address || '',
        tax_number: customer.tax_number || '',
        tax_office: customer.tax_office || '',
        notes: customer.notes || ''
      });
    } else {
      setEditingCustomer(null);
      setFormData({
        name: '',
        phone: '',
        email: '',
        address: '',
        tax_number: '',
        tax_office: '',
        notes: ''
      });
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingCustomer(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading(editingCustomer ? 'Güncelleniyor...' : 'Oluşturuluyor...');
    
    try {
      if (editingCustomer) {
        const nameChanged = editingCustomer.name !== formData.name;
        const phoneChanged = editingCustomer.phone !== formData.phone;
        
        await updateCustomer(editingCustomer.id, formData);
        
        if (nameChanged || phoneChanged) {
          try {
            const ordersRes = await getOrders({ limit: 500 });
            const customerOrders = (ordersRes.data.items || ordersRes.data).filter(order =>
              order.customer_id === editingCustomer.id
            );
            
            for (const order of customerOrders) {
              await updateOrder(order.id, {
                ...order,
                customer_name: formData.name,
                customer_phone: formData.phone
              });
            }
            
            if (customerOrders.length > 0) {
              toast.success(`${customerOrders.length} sipariş güncellendi`, { duration: 2000 });
            }
          } catch (e) {
            console.log('Sipariş güncelleme uyarısı:', e);
          }
        }
        
        toast.success('Müşteri güncellendi!', { id: loadingToast });
      } else {
        await createCustomer(formData);
        toast.success('Müşteri oluşturuldu!', { id: loadingToast });
      }
      handleCloseModal();
      fetchCustomers();
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'İşlem başarısız', { id: loadingToast });
    }
  };

  const handleViewOrders = async (customer) => {
    setSelectedCustomer(customer);
    setOrdersLoading(true);
    setIsOrdersModalOpen(true);
    
    try {
      const response = await getOrders({ limit: 500 });
      const orders = (response.data.items || response.data).filter(order =>
        order.customer_id === customer.id || 
        order.customer_name?.toLowerCase() === customer.name?.toLowerCase()
      );
      setCustomerOrders(orders);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Siparişler yüklenirken hata oluştu');
    } finally {
      setOrdersLoading(false);
    }
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectMode, setSelectMode] = useState(false);


  const handleCloseOrdersModal = () => {
    setIsOrdersModalOpen(false);
    setSelectedCustomer(null);
    setCustomerOrders([]);
  };
  const handleBulkDelete = () => {
    setConfirmModal({
      isOpen: true,
      title: 'Toplu Müşteri Silme',
      message: `${selectedIds.length} müşteriyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!`,
      type: 'danger',
      confirmText: `Evet, ${selectedIds.length} Müşteriyi Sil`,
      loading: false,
      onConfirm: handleBulkDeleteConfirm
    });
  };

  const handleBulkDeleteConfirm = async () => {
    setConfirmModal(prev => ({ ...prev, loading: true }));
    try {
      await bulkDeleteCustomers(selectedIds);
      toast.success(`${selectedIds.length} müşteri silindi`);
      setSelectedIds([]);
      setConfirmModal(prev => ({ ...prev, isOpen: false }));
      fetchCustomers(currentPage);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Silme hatası');
      setConfirmModal(prev => ({ ...prev, loading: false }));
    }
  };

  const handleDeleteClick = (customer) => {
    setConfirmModal({
      isOpen: true,
      title: 'Müşteri Silme',
      message: `"${customer.name}" isimli müşteriyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!`,
      type: 'danger',
      confirmText: 'Evet, Sil',
      loading: false,
      onConfirm: () => handleDeleteConfirm(customer.id)
    });
  };

  const handleDeleteConfirm = async (id) => {
    setConfirmModal(prev => ({ ...prev, loading: true }));
    
    try {
      await deleteCustomer(id);
      toast.success('Müşteri silindi');
      setConfirmModal(prev => ({ ...prev, isOpen: false }));
      fetchCustomers();
    } catch (error) {
      console.error('Error:', error);
      setConfirmModal(prev => ({ ...prev, isOpen: false, loading: false }));
      toast.error(error.response?.data?.detail || 'Silme hatası', { duration: 3000 });
    }
  };

  const handleExport = async () => {
  const loadingToast = toast.loading('Veriler hazırlanıyor...');
  try {
    const params = { page: 1, limit: 1000 };
    if (searchTerm) params.search = searchTerm;
    const res = await getCustomers(params);
    exportCustomersToExcel(res.data.items);
    toast.success(`${res.data.items.length} müşteri indirildi!`, { id: loadingToast });
  } catch (error) {
    toast.error('İndirme hatası', { id: loadingToast });
  }
};

  const getStatusLabel = (status) => {
    const labels = {
      'siparis_alindi': 'Sipariş Alındı',
      'uretimde': 'Üretimde',
      'teslim_edildi': 'Teslim Edildi'
    };
    return labels[status] || status;
  };

  const getStatusClass = (status) => {
    const classes = {
      'siparis_alindi': 'badge-info',
      'uretimde': 'badge-warning',
      'teslim_edildi': 'badge-success'
    };
    return classes[status] || 'badge-secondary';
  };

  const calculateCustomerStats = () => {
    const totalOrders = customerOrders.length;
    const totalRevenue = customerOrders.reduce((sum, order) => sum + (order.total_price || 0), 0);
    const totalPaid = customerOrders.reduce((sum, order) => sum + (order.total_paid || 0), 0);
    const completedOrders = customerOrders.filter(o => o.status === 'teslim_edildi').length;
    
    return { totalOrders, totalRevenue, totalPaid, completedOrders };
  };

  // Satır için kalan bakiye hesapla ve renk belirle
  const getRowClassName = (order) => {
    const remaining = (order.total_price || 0) - (order.total_paid || 0);
    if (remaining <= 0) {
      return 'row-paid';
    }
    return 'row-unpaid';
  };

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  return (
    <div className="page-container">
      <Navbar />

      <div className="page-content">
        <div className="page-header">
          <h2>Müşteriler ({totalCount})</h2>
          <div className="header-actions">
            <button className="btn-export" onClick={handleExport}>
              📥 Excel'e Aktar
            </button>
            {selectMode ? (
            <>
            {selectedIds.length > 0 && hasPermission('delete_customers') && (
              <button
                onClick={handleBulkDelete}
                style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#ff5252,#d32f2f)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="3 6 5 6 21 6"/>
                  <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                  <path d="M10 11v6M14 11v6"/>
                  <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                </svg>
                Seçilenleri Sil ({selectedIds.length})
              </button>
            )}
            <button
              onClick={() => { setSelectMode(false); setSelectedIds([]); }}
              style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
              İptal
            </button>
          </>
        ) : (
          hasPermission('delete_customers') && (
            <button
              onClick={() => setSelectMode(true)}
              style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#667eea,#764ba2)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <rect x="3" y="3" width="18" height="18" rx="3"/>
                <path d="M7 12l4 4 6-7"/>
              </svg>
              Seç
            </button>
          )
        )}
        {hasPermission('create_customers') && (
          <button className="btn-primary" onClick={() => handleOpenModal()}>
            + Yeni Müşteri
          </button>
        )}
          </div>
        </div>

        <div className="filters">
          <input
            type="text"
            placeholder="İsim, telefon veya email ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="table-container">
          <table>
            <thead>
             <tr>
                 {selectMode && (
                  <th style={{width: '40px'}}>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedIds(customers.map(c => c.id));
                        } else {
                          setSelectedIds([]);
                        }
                      }}
                      checked={selectedIds.length === customers.length && customers.length > 0}
                    />
                  </th>
                )}
                <th>Ad Soyad</th>
                <th>Telefon</th>
                <th>Email</th>
                <th>Adres</th>
                <th>Vergi No</th>
                <th>Vergi Dairesi</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {customers.map(customer => (
                <tr key={customer.id}>
                  {selectMode && (
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(customer.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedIds(prev => [...prev, customer.id]);
                          } else {
                            setSelectedIds(prev => prev.filter(id => id !== customer.id));
                          }
                        }}
                      />
                    </td>
                  )}
                  <td title={`#${customer.id}`}>{customer.name}</td>
                  <td>{customer.phone || '-'}</td>
                  <td>{customer.email || '-'}</td>
                  <td>{customer.address || '-'}</td>
                  <td>{customer.tax_number || '-'}</td>
                  <td>{customer.tax_office || '-'}</td>
                  <td>
                    <div className="action-buttons">
                      <button 
                        className="btn-view"
                        onClick={() => handleViewOrders(customer)}
                        title="Sipariş Geçmişi"
                      >
                        📋
                      </button>
                      {hasPermission('edit_customers') && (
                        <button className="btn-edit" onClick={() => handleOpenModal(customer)} title="Düzenle">
                          ✎
                        </button>
                      )}
                      {hasPermission('delete_customers') && (
                        <button className="btn-delete" onClick={() => handleDeleteClick(customer)} title="Sil">
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                            <path d="M10 11v6M14 11v6"/>
                            <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                          </svg>
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalCount > 0 && (
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'20px', flexWrap:'wrap'}}>
          
          <select 
            value={pageSize} 
            onChange={(e) => { 
              const newSize = Number(e.target.value);
              setPageSize(newSize); 
              localStorage.setItem('customerPageSize', newSize);
              fetchCustomers(1, searchTerm, newSize); 
            }} 
            style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'14px', background:'white'}}
          > 
            <option value={50}>50 kayıt</option> 
            <option value={100}>100 kayıt</option> 
            <option value={250}>250 kayıt</option>
          </select>

          <button onClick={() => { window.scrollTo(0,0); fetchCustomers(1, searchTerm); }} disabled={currentPage===1}
            style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===1?'not-allowed':'pointer', background:currentPage===1?'#f5f5f5':'white'}}>«</button>
          <button onClick={() => { window.scrollTo(0,0); fetchCustomers(currentPage-1, searchTerm); }} disabled={currentPage===1}
            style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===1?'not-allowed':'pointer', background:currentPage===1?'#f5f5f5':'white'}}>‹</button>

          {totalPages > 1 && Array.from({length: totalPages}, (_, i) => i+1)
            .filter(p => p===1 || p===totalPages || Math.abs(p-currentPage)<=2)
            .reduce((acc, p, i, arr) => {
              if (i > 0 && p - arr[i-1] > 1) acc.push('...');
              acc.push(p);
              return acc;
            }, [])
            .map((p, i) => p==='...' ? (
              <span key={`dots-${i}`} style={{padding:'8px 4px'}}>...</span>
            ) : (
              <button key={p} onClick={() => { window.scrollTo(0,0); fetchCustomers(p, searchTerm); }}
                style={{padding:'8px 14px', borderRadius:'6px',
                  border:`1px solid ${currentPage===p?'#667eea':'#ddd'}`,
                  background:currentPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white',
                  color:currentPage===p?'white':'#333',
                  cursor:'pointer', fontWeight:currentPage===p?'600':'normal'}}>
                {p}
              </button>
            ))
          }

          <button onClick={() => { window.scrollTo(0,0); fetchCustomers(currentPage+1, searchTerm); }} disabled={currentPage===totalPages}
            style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===totalPages?'not-allowed':'pointer', background:currentPage===totalPages?'#f5f5f5':'white'}}>›</button>
          <button onClick={() => { window.scrollTo(0,0); fetchCustomers(totalPages, searchTerm); }} disabled={currentPage===totalPages}
            style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===totalPages?'not-allowed':'pointer', background:currentPage===totalPages?'#f5f5f5':'white'}}>»</button>

          <span style={{color:'#666', fontSize:'14px', marginLeft:'8px'}}>
          {((currentPage - 1) * pageSize) + 1}-{Math.min(currentPage * pageSize, totalCount)} / {totalCount} müşteri | Sayfa {currentPage} / {totalPages}
        </span>
        </div>
      )}

      </div>
      
      {/* Müşteri Oluştur/Düzenle Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={editingCustomer ? 'Müşteri Düzenle' : 'Yeni Müşteri'}
        size="large"
      >
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Ad Soyad *</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
              />
            </div>
            <div className="form-group">
              <label>Telefon</label>
              <input
                type="text"
                value={formData.phone}
                onChange={handlePhoneChange}
                placeholder="0(5XX) XXX XX XX"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>Adres</label>
            <textarea
              value={formData.address}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Vergi Numarası</label>
              <input
                type="text"
                value={formData.tax_number}
                onChange={(e) => setFormData({...formData, tax_number: e.target.value})}
              />
            </div>
            <div className="form-group">
              <label>Vergi Dairesi</label>
              <input
                type="text"
                value={formData.tax_office}
                onChange={(e) => setFormData({...formData, tax_office: e.target.value})}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Notlar</label>
            <textarea
              value={formData.notes}
              onChange={(e) => setFormData({...formData, notes: e.target.value})}
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
              İptal
            </button>
            <button type="submit" className="btn btn-primary">
              {editingCustomer ? 'Güncelle' : 'Oluştur'}
            </button>
          </div>
        </form>
      </Modal>

      {/* Sipariş Geçmişi Modal */}
      <Modal
        isOpen={isOrdersModalOpen}
        onClose={handleCloseOrdersModal}
        title={`${selectedCustomer?.name} - Sipariş Geçmişi`}
        size="xlarge"
      >
        {ordersLoading ? (
          <div className="modal-loading">Yükleniyor...</div>
        ) : (
          <>
            {customerOrders.length > 0 && (
              <div className="customer-stats">
                <div className="stat-card">
                  <span className="stat-value">{calculateCustomerStats().totalOrders}</span>
                  <span className="stat-label">Toplam Sipariş</span>
                </div>
                <div className="stat-card">
                  <span className="stat-value">{calculateCustomerStats().completedOrders}</span>
                  <span className="stat-label">Tamamlanan</span>
                </div>
                <div className="stat-card">
                  <span className="stat-value">{formatCurrency(calculateCustomerStats().totalRevenue)}</span>
                  <span className="stat-label">Toplam Tutar</span>
                </div>
                <div className="stat-card">
                  <span className="stat-value">{formatCurrency(calculateCustomerStats().totalPaid)}</span>
                  <span className="stat-label">Ödenen</span>
                </div>
              </div>
            )}

            {customerOrders.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">📭</div>
                <p>Bu müşteriye ait sipariş bulunmuyor</p>
              </div>
            ) : (
              <div className="table-container" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <table>
                  <thead>
                    <tr>
                      <th>Sipariş No</th>
                      <th>Tarih</th>
                      <th>İş Türü</th>
                      <th>Açıklama</th>
                      <th>Durum</th>
                      <th>Tutar</th>
                      <th>Ödenen</th>
                      <th>Kalan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customerOrders.map(order => {
                      const remaining = (order.total_price || 0) - (order.total_paid || 0);
                      return (
                        <tr key={order.id} className={getRowClassName(order)}>
                          <td><strong>#{order.id}</strong></td>
                          <td>{formatDate(order.order_date)}</td>
                          <td>{order.job_type || '-'}</td>
                          <td className="description-cell">{order.description || '-'}</td>
                          <td>
                            <span className={`badge ${getStatusClass(order.status)}`}>
                              {getStatusLabel(order.status)}
                            </span>
                          </td>
                          <td>{formatCurrency(order.total_price)}</td>
                          <td>{formatCurrency(order.total_paid || 0)}</td>
                          <td className={remaining > 0 ? 'text-danger' : 'text-success'}>
                            {formatCurrency(remaining)}

                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </Modal>

      {/* Onay Modalı */}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal(prev => ({ ...prev, isOpen: false }))}
        onConfirm={confirmModal.onConfirm}
        title={confirmModal.title}
        message={confirmModal.message}
        type={confirmModal.type}
        confirmText={confirmModal.confirmText}
        loading={confirmModal.loading}
      />
    </div>
  );
}

export default Customers;